export const GetAllTxn = async () => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`
        },
        redirect: "follow",
    };

    try {
        const response = await fetch(`${ApiURL}ledger/TXN`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return result.data;
        } else {
            throw new Error("Request was not successful");
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        return [];
    }
};



export const getAllLocations = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var requestOptions = {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
    }
    await fetch(`${ApiURL}Locations`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                var dataset = []
                result.data.map((dr, index) => {
                    dataset.push({
                        id: index + 1,
                        name: dr.name,
                        code: dr.code,
                        state: false
                    })
                })

                data = dataset
            }
        })
        .catch(error => console.log("error", error))

    return data
}



export const getAllCostCenters = async () => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: "follow",
    };

    try {
        const response = await fetch(`${ApiURL}ledger/costcenters`, requestOptions);
        const result = await response.json();
        if (result.success) {
            return result.data;
        } else {
            throw new Error("Request was not successful");
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        return [];
    }
};



export const getLedgerDetails = async (searchLedger) => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const params = new URLSearchParams(searchLedger); // Encode searchLedger as query parameters

    try {
        const requestOptions = {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${authToken}`,
            },
            redirect: "follow",
        };

        const response = await fetch(`${ApiURL}Ledger?${params}`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return result.data; // return the fetched result
        }
    } catch (error) {
        console.log("error", error);
    }

    return []; // return null if the fetch was unsuccessful or no data found
};



export const LoadBeforeSaveLedgerDetails = async (transaction, location, ledgerSelectedDocs) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");


        var object = {
            "transaction": transaction,
            "location": location,
            "ledgerSelectedDocs": ledgerSelectedDocs
        }

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(object)
        };

        const response = await fetch(`${ApiURL}Ledger`, requestOptions);

        // if (!response.ok) {
        //     throw new Error("Failed to save ledger details");
        // }

        const result = await response.json();
        if (!result.success) {
            return [];
        }

        return result.data;
    } catch (error) {
        console.error("SaveLedgerDetails error:", error);
        //throw error; // Rethrow the error to be handled by the caller
    }
};




export const SaveLedgerDetails = async (transaction, location, LogUserType, company, ledgerSelectedDocs) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        var responseStatus = false;
        var responseData = ""
        var responseError = ""

        //get last tow digits of the year
        var d = new Date();
        var finalYear = d.getFullYear().toString().slice(-2);


        var object = {
            "docType": "Job",
            "finalYear": finalYear.toString(),
            "company": company,
            "transaction": transaction,
            "location": location,
            "loguser": LogUserType,
            "ledgerSelectedDocs": ledgerSelectedDocs
        }

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(object)
        };

        const response = await fetch(`${ApiURL}Ledger/save`, requestOptions);
        const result = await response.json();

        responseStatus = result.success;
        responseData = result.data;
        responseError = result.msg;

        return { responseStatus, responseData, responseError };
    } catch (error) {
        console.error("SaveLedgerDetails error:", error);
        //throw error; // Rethrow the error to be handled by the caller
        return { responseStatus: false, responseData: "", responseError: error };
    }
};
